module.exports = __webpack_public_path__ + "img/main-map.8f429356.svg";